function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (n, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : n.viewportDetection = t();
}(this, function () {
  "use strict";

  var n = function n(_n) {
    return function (t) {
      for (var e in _n) {
        if (_n[e]) {
          var i = _n[e],
              r = i.min,
              o = i.max;
          if (null === o && t >= r) return e;
          if (t >= r && t < o) return e;
        }
      }

      return null;
    };
  },
      t = function t(n, _t) {
    return -1 != n.indexOf(_t);
  },
      e = function e(_e, i) {
    var r = n(_e)(i),
        o = Object.keys(_e);
    return function (n) {
      return t(o, n) ? r = n : r;
    };
  },
      i = function i(n) {
    window.addEventListener("resize", n, !1), window.addEventListener("orientationchange", n, !1);
  },
      r = function r(t, e, i) {
    var r = i,
        o = n(t);
    return e(o(r)), function (n) {
      if (n === r) return !1;
      var t = o(r = n);
      return null !== t && e() !== t && (e(t), !0);
    };
  },
      o = function o() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  };

  return function (n) {
    var t = n || {
      mobile: {
        min: 0,
        max: 767
      },
      tablet: {
        min: 768,
        max: 1023
      },
      desktop: {
        min: 1024,
        max: null
      }
    },
        u = window.innerWidth,
        c = e(t, u),
        f = [],
        a = o(),
        d = r(t, c, u),
        l = {
      addCallback: function addCallback(n) {
        return "[object Function]" === Object.prototype.toString.call(n) && (n = [n]), f = f.concat(n), l;
      },
      getDevice: function getDevice() {
        return c();
      },
      getWidth: function getWidth() {
        return u;
      },
      track: function track() {
        i(function () {
          var n = window.innerWidth;
          d(n) && (u = n, f.forEach(function (t) {
            t(c(), n);
          }));
        });
      },
      touchAvailable: function touchAvailable() {
        return a;
      }
    };
    return l;
  };
});